import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import OneDeployment from './chatbot/OneDeployment';
import FullBook from './chatbot/FullBook';
import LisasInterview from './chatbot/LisasInterview';
import Stories from './chatbot/Stories';
import FinalInterview from './chatbot/final-interview';
import MilitaryDemo from './chatbot/military_demo_set';
import EarlyLife from './chatbot/Early_Life';
import EarlyCareer from './chatbot/Early_Career';
import LaterCareer from './chatbot/Later_Career';
import reflections from './chatbot/reflections';
import Month1 from './chatbot/m0261';
import Month1b from './chatbot/m0261b';
import Job1 from './chatbot/Job1';
import Grandparents from './chatbot/d_gpts';
import Sports from './chatbot/d_sports';
import Family from './chatbot/d_fam';
import Month2 from './chatbot/m0262a';
import Month3 from './chatbot/m0263a';
import Month3b from './chatbot/m0263b';
import Month4 from './chatbot/m0264a';
import CR10 from './chatbot/CR10';
import Month5 from './chatbot/m0265a';
import Month8 from './chatbot/m0268a';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/one" />} />
        <Route path="/one" element={<OneDeployment />} />
        <Route path="/book" element={<FullBook />} />
		<Route path="/Lisa" element={<LisasInterview/>} />
		<Route path="/stories" element={<Stories/>} />
		<Route path="/final-interview" element={<FinalInterview/>} />
		<Route path="/demo" element={<MilitaryDemo/>} />
		<Route path="/early-life" element={<EarlyLife/>} />
		<Route path="/early-career" element={<EarlyCareer/>} />
		<Route path="/later-career" element={<LaterCareer/>} />
		<Route path="/reflections" element={<reflections/>} />
		<Route path="/m0261" element={<Month1/>} />
		<Route path="/m0261b" element={<Month1b/>} />
		<Route path="/Job1" element={<Job1/>} />
		<Route path="/d_gpts" element={<Grandparents/>} />
		<Route path="/d_sports" element={<Sports/>} />
		<Route path="/d_fam" element={<Family/>} />
		<Route path="/m0262a" element={<Month2/>} />
		<Route path="/m0263a" element={<Month3/>} />
		<Route path="/m0263b" element={<Month3b/>} />
		<Route path="/m0264a" element={<Month4/>} />
		<Route path="/CR10" element={<CR10/>} />
		<Route path="/m0265a" element={<Month5/>} />
		<Route path="/m0268a" element={<Month8/>} />
      </Routes>
    </Router>
  );
}

export default App;
